import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getPackagePurchaseReport, getPlayerPaymentHistoryReport } from "../../../services/ReportService";

const PackagePurchaseModal = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetchPreviewData();
    }
  }, [show]);

  const fetchPreviewData = async () => {
    setLoading(true);
    try {
      const res = await getPackagePurchaseReport(0, 10, "");
      const items = Array.isArray(res) ? res : res?.content || res?.data || [];
      setData(items);
    } catch (error) {
      console.error("Error fetching preview package purchase data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowMore = () => {
    onHide();
    navigate("/admin/package-purchase-reports");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-18 fw-bold">
          <i className="fas fa-box-open text-warning me-2"></i>
          Package Purchase - Recent Purchases
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="warning" />
            <p className="mt-2 text-muted">Loading package purchases...</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover responsive className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Player Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Package</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="fw-semibold">
                        {item?.player?.name || item?.name || "-"}
                      </td>
                      <td>{item?.player?.email || item?.phone || "-"}</td>
                      <td>{item?.player?.phone || item?.phone || "-"}</td>
                      <td>
                        {item?.playerSubscription?.packageType?.name ||
                          item?.subscription?.packageType?.name ||
                          item?.package?.name ||
                          item?.packageType ||
                          "-"}
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center py-4 text-muted">
                      No recent package purchases found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleShowMore}>
          <i className="fas fa-external-link-alt me-2"></i> Show More (View Full Report)
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PackagePurchaseModal;
